import * as emblaCarousel from './embla-carousel';
import * as calendar from './calendar';
import * as disclosure from './disclosure';
import * as modal from './modal';
import * as productionStickyPerformances from './production-sticky-performances';
import * as popover from './popover';
import * as whatsOnCalendar from './whats-on-calendar';
import { nodeConfig } from '@scripts/mixins';
import { updateInstances } from '@scripts/helpers/modules-loader';

const DYNAMIC_COMPONENT_LOOKUP = {
	[emblaCarousel.DEFAULT_SELECTOR]: {
		module: emblaCarousel.CarouselEmbla,
		namespace: emblaCarousel.NAMESPACE,
		settings: emblaCarousel.DEFAULT_SETTINGS,
	},
	[calendar.DEFAULT_SELECTOR]: {
		module: calendar.Calendar,
		namespace: calendar.NAMESPACE,
		settings: calendar.DEFAULT_SETTINGS,
	},
	[disclosure.DEFAULT_SELECTOR]: {
		module: disclosure.Disclosure,
		namespace: disclosure.NAMESPACE,
		settings: disclosure.DEFAULT_SETTINGS,
	},
	[modal.DEFAULT_SELECTOR]: {
		module: modal.Modal,
		namespace: modal.NAMESPACE,
		settings: modal.DEFAULT_SETTINGS,
	},
	[productionStickyPerformances.DEFAULT_SELECTOR]: {
		module: productionStickyPerformances.ProductionStickyPerformances,
		namespace: productionStickyPerformances.NAMESPACE,
		settings: productionStickyPerformances.DEFAULT_SETTINGS,
	},
	[popover.DEFAULT_SELECTOR]: {
		module: popover.Popover,
		namespace: popover.NAMESPACE,
		settings: popover.DEFAULT_SETTINGS,
	},
	[whatsOnCalendar.DEFAULT_SELECTOR]: {
		module: whatsOnCalendar.WhatsOnCalendar,
		namespace: whatsOnCalendar.NAMESPACE,
		settings: whatsOnCalendar.DEFAULT_SETTINGS,
	}
};

class Page {
	constructor() {
		this.elNode = document.body;
	}

	init() {
		this.elNode.classList.remove('preload');
		this.elNode.classList.add('loaded');

		window.addEventListener('servd.dynamicloaded', function (e) {
			let blocks = e?.detail?.blocks;
			if (!blocks || !Array.isArray(blocks)) return;

			blocks.filter((block) => block instanceof Element)
				.forEach((block) => {
					for (const [selector, component] of Object.entries(DYNAMIC_COMPONENT_LOOKUP)) {
						if (block.matches(selector)) {
							const config = nodeConfig(block, component.namespace, component.settings);

							const module = new component.module(block, config);
							module.init();

							updateInstances(component.namespace, module);
						}

						const childInstances = block.querySelectorAll(selector);
						childInstances.forEach((child) => {
							const config = nodeConfig(child, component.namespace, component.settings);

							const module = new component.module(child, config);
							module.init();
							updateInstances(component.namespace, module);
						});
					}
				});
		});
	}
}

export default function factory() {
	const module = new Page();

	module.init();

	return module;
}
